<template>
  <div>
    <div class="toolsb">
      <el-input class="mb-input" placeholder="请输入课时名称" v-model="query.classesName"></el-input>
      <el-button type="primary" @click="queryData">搜索</el-button>
      <el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button type="danger" @click="deleteData">批量删除</el-button>
      <el-button type="danger" @click="clearData">一键清除</el-button>
    </div>
    <ul class="record">
      <template v-for="(tditem, tdindex) in tableData">
        <li v-bind:key="tdindex">
          <div class="fr">
            <span class="m-date">{{tditem.date}}</span>
            <span class="time-line">
              <span class="solid-circle"></span>
              <span class="decorate-line-b"></span>
            </span>
            <el-checkbox style="position: relative;top:-4px" :indeterminate="isIndeterminate" v-model="tditem.checked" @change="handleCheckAllChange(tdindex)">全选</el-checkbox>
          </div>
          <el-checkbox-group v-model="historyIds" @change="handleCheckedChange(tdindex)">
            <ul>
              <template v-for="(tdsubitem, tdsubindex) in tditem.data">
                <li v-bind:key="tdsubindex" class="fr">
                  <span class="m-time">{{tdsubitem.learnTime}}</span>
                  <span class="time-line">
                    <span class="hollow-circle"></span>
                    <span class="decorate-line"></span>
                  </span>
                  <!--v-bind:value="tdsubitem.historyId"-->
                  <el-checkbox style="position: relative;top:-4px" :label="tdsubitem.historyId"></el-checkbox>
                  <ul class="m-time-info" @click="studyTap(tdsubitem)">
                    <li class="mti-i"><span style="color: #a9a9ab">所属课程: </span><span style="color: #1e6af3">{{tdsubitem.courseName}}</span></li>
                    <li class="mti-i"><span style="color: #a9a9ab">所属章节: </span><span>{{tdsubitem.classesName}}</span></li>
                    <li class="mti-i"><span style="color: #a9a9ab">课时: </span><span>{{tdsubitem.classesName}}</span></li>
                    <li class="mti-i"><span style="color: #a9a9ab">授课教师: </span><span>{{tdsubitem.teacherName}}</span></li>
                    <li class="mti-i"><span style="color: #a9a9ab">当前学习时长: </span><span>{{tdsubitem.curVideoTime | timeFilter}}</span></li>
                    <li class="mti-i"><span style="color: #a9a9ab">当前课时总时长: </span><span>{{tdsubitem.totalVideoTime | timeFilter}}</span></li>
                  </ul>
                </li>
              </template>
            </ul>
          </el-checkbox-group>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import TimeUtil from "@/utils/TimeUtil";
export default {
  name: "StudentRecord",
  data () {
    return {
      tableData: [],
      query: {
        classesName: ""
      },
      historyIds: [],
      isIndeterminate: false
    };
  },
  filters: {
    timeFilter (value) {
      return TimeUtil.formatSeconds(value);
    }
  },
  mounted () {
    this.queryData();
  },
  methods: {
    queryData () {
      let that = this;
      that.HttpConnection.get("/learn/history/list", {
        params: {
          classesName: that.query.classesName
        }
      }).then(function (response) {
        that.tableData = response.data;
      });
    },
    resetQuery () {
      this.query = {};
      this.queryData();
    },
    clearData () {
      let that = this;
      that.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(() => {
        that.HttpConnection.post("/learn/history/clear").then(function (response) {
          that.queryData();
          that.$message({
            type: "success",
            message: "清除成功"
          });
        });
      });
    },
    deleteData () {
      let that = this;
      that.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(() => {
        that.HttpConnection.post("/learn/history/batchDelete", that.historyIds).then(function (response) {
          that.queryData();
          that.$message({
            type: "success",
            message: "删除成功"
          });
        });
      });
    },
    handleCheckAllChange (index) {
      let val = this.tableData[index].checked;
      let _historyIds = [];
      for (let item of this.tableData[index].data) {
        if (val) {
          _historyIds.push(item.historyId);
        }
      }
      this.historyIds = _historyIds;
      this.isIndeterminate = false;
    },
    handleCheckedChange (index) {
      let checkedCount = this.historyIds.length;
      let tableDataCount = this.tableData[index].data.length;
      this.$set(this.tableData[index], "checked", checkedCount === tableDataCount);
      this.isIndeterminate = checkedCount > 0 && checkedCount < tableDataCount;
    },
    studyTap (tdsubitem) {
      let _classInfo = {
        teacherId: tdsubitem.teacherId,
        teacherName: tdsubitem.teacherName,
        classId: this.classId,
        classesId: tdsubitem.classesId,
        classesName: tdsubitem.classesName,
        classesType: tdsubitem.classesType,
        videoName: tdsubitem.videoName,
        videoUrl: tdsubitem.videoUrl,
        materialsName: tdsubitem.materialsName,
        materialsUrl: tdsubitem.materialsUrl
      };
      console.log("_classInfo----->", _classInfo);
      // sessionStorage.setItem("classInfo", JSON.stringify(_classInfo));
      // this.$store.commit("clearLiveMessage");
      // let _routeUrl = this.$router.resolve({ path: "/RoomEnter" });
      // window.open(_routeUrl.href, "_blank");
      // this.$router.push({ path: "/RoomEnter" });
    }
  }
};
</script>

<style scoped lang="scss">
.record {
  margin: 40px 0px 0px 0px;
}
.m-date {
  width: 100px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  background-color: #1e6af3;
  position: relative;
  top: -7px;
  color: #ffffff;
}
.m-date:after {
  content: "";
  position: absolute;
  top: 7px;
  right: -12px;
  width: 0px;
  height: 0px;
  border-width: 6px;
  border-style: dashed dashed dashed solid;
  border-color: transparent transparent transparent #1e6af3;
}
.m-time {
  width: 100px;
  min-width: 100px;
  text-align: right;
  position: relative;
  top: -5px;
}
.solid-circle {
  width: 10px;
  height: 10px;
  background-color: #1e6af3;
  border-radius: 10px;
}
.hollow-circle {
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  border: 2px solid #1e6af3;
}
.decorate-line {
  width: 1px;
  height: 98%;
  background-color: #1e6af3;
}
.decorate-line-b {
  width: 1px;
  height: 60px;
  background-color: #1e6af3;
}
.time-line {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px 10px;
}
.m-time-info {
  padding: 10px 20px;
  background-color: #f6f7fb;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0px 0px 40px 10px;
  .mti-i {
    width: 340px;
    margin: 10px 0px;
  }
}
.el-checkbox-group {
  font-size: 16px;
}
/deep/ .el-checkbox__label {
  display: none !important;
}
</style>
